// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import Login from "./Auth/Login/Login.jsx";
import Signup from "./Auth/Signup/SignUp.jsx";
import ProductDetails from "./components/ProductDetail.jsx";
import reportWebVitals from "./reportWebVitals.js";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CartScreen from "./files/CartScreen/CartScreen.jsx";
import Checkout from "./files/checkout/CheckoutScreen.jsx";
import { CartProvider } from "./utils/cartContext.js";
import { AuthProvider } from "./utils/AuthContext.js";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { CookiesProvider } from "react-cookie";
import ProtectedRoute from "./utils/ProtectedRoute.js";
import MyOrderScreen from "./files/MyOrderScreen/MyOrderScreen.jsx";
import MyOrderDetailScreen from "./files/MyOrderDetails/MyOrderDetailsScreen.jsx";
import { SearchProvider } from "./utils/SearchContext.js";
import ProductSearch from "./files/ProductSearch/ProductSearch.jsx";
import ServiceSubCategoryScreen from "./files/ServiceSubCategoryScreen/ServiceSubCategoryScreen.jsx";
import ServiceSearchScreen from "./files/ServiceSearch/ServiceSearchScreen.jsx";
import ListOrderHistory from "./files/ListOrderHistory/ListOrderHistory.jsx";
import ServiceBookingHistory from "./files/ServiceBooking/ServiceBooking.jsx";
import BrowseServices from "./files/BrowseService/BrowseService.jsx";
import ServiceProviderDetails from "./files/ServiceProviderDetails/ServiceProviderDetails.jsx";
import StoreDetailScreen from "./files/StoreDetailScreen/StoreDetailScreen.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy.jsx";
import SavedStoresPage from "./files/savedStorePage/savedStorePage.jsx";
import SavedProductsPage from "./files/SavedProductPage/SavedProductPage.jsx";
import SuccessScreen from "./files/SuccessScreen/SuccessScreen.jsx";
import ChangePasswordMobile from "./files/ChangePassword/ChangePassword.jsx";
import MyRewardScreen from "./files/MyRewardScreen/MyRewardScreen.jsx";
import ForgotPasswordScreen from "./Auth/forgetPasswordScreen/ForgetPasswordScreen.jsx";
import BulkOrderComponent from "./files/BulkOrder/BulkOrder.jsx";
import HelpCenter from "./components/HelpCentre/HelpCentre.jsx";
import CategoryProductScreen from "./files/CategoryProductScreen/CategoryProductScreen.jsx";
import NotFound from "./components/notfound.jsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/home",
    element: <App />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordScreen />,
  },

  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/savedShops",
    element: <SavedStoresPage />,
  },
  {
    path: "/savedProducts",
    element: <SavedProductsPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cartScreen",
    element: <CartScreen />,
  },
  {
    path: "/categoryProductScreen",
    element: <CategoryProductScreen />,
  },

  {
    path: "/service-subcategories/:category",
    element: <ServiceSubCategoryScreen />,
  },
  {
    path: "/provider-details/:encryptedProviderMobile",
    element: <ServiceProviderDetails />,
  },
  {
    path: "/bulk-order/:encryptedProviderMobile",
    element: <BulkOrderComponent />,
  },
  {
    path: "/store-detail/:encryptedMobile",
    element: <StoreDetailScreen />,
  },
  {
    path: "/reward",
    element: <MyRewardScreen />,
  },
  {
    path: "/help-center",
    element: <HelpCenter />,
  },
  {
    path: "/myorder",
    element: (
      <ProtectedRoute>
        <MyOrderScreen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/myorderdetails/:encryptOrderNumber",
    element: (
      <ProtectedRoute>
        <MyOrderDetailScreen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/searchProduct/:searchterm",
    element: <ProductSearch />,
  },
  {
    path: "/searchService/:searchTerm",
    element: <ServiceSearchScreen />,
  },
  {
    path: "/browseService/:subcategory",
    element: <BrowseServices />,
  },
  {
    path: "/checkout",
    element: (
      <ProtectedRoute>
        <Checkout />
      </ProtectedRoute>
    ),
  },
  {
    path: "/listOrder",
    element: (
      <ProtectedRoute>
        <ListOrderHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/serviceBookingHistory",
    element: (
      <ProtectedRoute>
        <ServiceBookingHistory />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product/:id/:encodedProductName",
    element: <ProductDetails />,
  },
  {
    path: "/successScreen",
    element: <SuccessScreen />,
  },
  {
    path: "/change-password",
    element: <ChangePasswordMobile />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <AuthProvider>
        <CartProvider>
          <SearchProvider>
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <RouterProvider router={router} />
          </SearchProvider>
        </CartProvider>
      </AuthProvider>
    </CookiesProvider>
  </React.StrictMode>
);

reportWebVitals();
